import { matchPath } from "react-router-dom"

export const matchRoute = (pathname: string, routes: Array<{path: string, key: string}>) => {
    for (const route of routes) {
        const match = matchPath(route.path, pathname)
        if (match) {
            return route.key
        }
    }
    return null
}